import { Car, ClipboardList, FileText, LayoutDashboard, Tag, Users } from 'lucide-react';
import { usePermissions } from '../../hooks/usePermissions';
import { useEnterpriseConfigContext } from '../../component/context/EnterpriseConfigContext';

/**
 * Abas do hub /dashboards/:tab — fonte única das 6 abas e dos seus gates, usada
 * pelo hub (chips), pelo menu (navConfig), pela Home (atalhos) e pelo "Mais" mobile.
 * Os gates são os mesmos que o menu lateral usava para o grupo "Dashboards":
 * a permissão do perfil (que já embute o módulo do plano) e, para Veículos,
 * também a config "Usa veículo" da empresa.
 */
export const DASHBOARD_TABS = [
    { id: 'sale', label: 'Vendas', permission: 'dashboard.sale', icon: LayoutDashboard, title: 'Abrir Dashboard de Vendas' },
    { id: 'order', label: 'Ordens', permission: 'dashboard.serviceorder', icon: ClipboardList, title: 'Abrir Dashboard de Ordens' },
    { id: 'vehicle', label: 'Veículos', permission: 'dashboard.vehicle', requiresVehicle: true, icon: Car, title: 'Abrir Dashboard de Veículos' },
    { id: 'quote', label: 'Orçamentos', permission: 'dashboard.servicequote', icon: FileText, title: 'Abrir Dashboard de Orçamentos' },
    { id: 'customer', label: 'Clientes', permission: 'dashboard.customer', icon: Users, title: 'Abrir Dashboard de Clientes' },
    { id: 'product', label: 'Produtos', permission: 'dashboard.product', icon: Tag, title: 'Abrir Dashboard de Produtos' },
];

export const dashboardTabPath = (id) => `/dashboards/${id}`;

/** Abas permitidas ao usuário atual, na ordem Vendas, Ordens, Veículos, Orçamentos, Clientes, Produtos. */
export function useAllowedDashboardTabs() {
    const { hasPermission } = usePermissions();
    const { settings } = useEnterpriseConfigContext();
    const vehicleEnabled = Boolean(settings?.os_use_vehicle);
    return DASHBOARD_TABS.filter((tab) => (
        hasPermission(tab.permission) && (!tab.requiresVehicle || vehicleEnabled)
    ));
}
